module.exports = __webpack_public_path__ + "static/online_fagseminar-cda937af6956e01fca2b4c82ab22ce3a.png";